/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC } from "react";
/* eslint-enable @typescript-eslint/no-unused-vars */
// antd:
import { Layout } from "antd";
// Components:
import LayoutMainToolbar from "../components/react/LayoutMainToolbar.tsx";
// Redux-hooks:
import { useAppSelector } from "../libs/redux-hooks.ts";
// Reducers:
import { getDict } from "../libs/reducer.ts";

// type componentProps = {children?:React.ReactNode}

const NotFoundPage:FC = () => {
  const stl1:{[key:string]:string} = {
    backgroundImage: "url('/img/bg/page-not-found.png')",
    backgroundColor: "rgba(70,70,70,100)",
    backgroundBlendMode: "multiply",
    OBackgroundSize: "cover",
    MozBackgroundSize: "cover",
    WebkitBackgroundSize: "cover",
    backgroundPosition: "center center"
  };

  const dct = useAppSelector(getDict);

  return (
    <Layout id="antd-layout" className="layout">
      <div id="background-image" style={stl1}>
        <LayoutMainToolbar />

        <div id="virtual-desktop" className="uk-container uk-container-expand uk-flex uk-flex-middle uk-flex-center rz-margin-top-80" style={{height: window.innerHeight - 82, width: "100%"}}>
          <h1 className="uk-margin-remove uk-text-center txt-white txt-stroke-blue-shadow">{dct.e.pageNotfoundOrDenied}</h1>
        </div>
      </div>
    </Layout>
  );
}

export default NotFoundPage;
